var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeSolid1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.07 35.1765C24.4486 35.1765 22.8272 34.6447 21.4442 33.5669L0.959961 17.6387V39.8846C0.959961 42.4839 3.06783 44.5927 5.66809 44.5927H46.4718C49.0721 44.5927 51.18 42.4849 51.18 39.8846V17.6387L30.6996 33.5777C29.3166 34.6468 27.6884 35.1765 26.07 35.1765ZM2.55778 14.9021L23.3716 31.0961C24.9596 32.332 27.1842 32.332 28.7722 31.0961L49.5861 14.9021C50.5032 14.1174 51.18 12.911 51.18 11.6359C51.18 9.0356 49.0711 6.92773 46.4718 6.92773H5.66809C3.06783 6.92773 0.959961 9.0356 0.959961 11.6359C0.959961 12.911 1.54946 14.1174 2.55778 14.9021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.22,
    height: 50.22,
    fill: "white",
    transform: "translate(0.959961 0.649902)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSolid1);
export default __webpack_public_path__ + "static/media/envelope-solid 1.f780d43e744a863fdfbe725df66446d5.svg";
export { ForwardRef as ReactComponent };